// src/modules/app-views/invoices/pages/Document/tabs/PreviewTab/ItemsSection.jsx
// *******************************************************************************
// ITEMS SECTION - DANFE NFC-e
// *******************************************************************************
// Displays the list of items/products in the invoice.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import financialService from 'services/financialService';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const ItemsSection = ({ data }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const items = data?.items || [];

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  if (!items.length) {
    return (
      <div className="danfe-section danfe-items">
        <Text type="secondary" style={{ fontSize: 11 }}>
          Nenhum item na nota fiscal.
        </Text>
      </div>
    );
  }

  return (
    <div className="danfe-section danfe-items">
      {/* Header */}
      <div className="danfe-items-header">
        <Text strong style={{ fontSize: 11 }}>
          ITENS
        </Text>
      </div>

      {/* Items Table */}
      <table className="danfe-items-table">
        <thead>
          <tr>
            <th style={{ width: 25, textAlign: 'center' }}>#</th>
            <th style={{ textAlign: 'left' }}>Descrição</th>
            <th style={{ width: 40, textAlign: 'center' }}>Qtd</th>
            <th style={{ width: 60, textAlign: 'right' }}>Unit</th>
            <th style={{ width: 70, textAlign: 'right' }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item, index) => {
            const itemNumber = item.itemNumber || index + 1;
            const description = item.description || item.productName || item.name || '-';
            const quantity = item.quantity || 0;
            const unitPrice = item.unitPrice || item.unitValue || 0;
            const totalPrice = item.totalPrice || item.totalValue || quantity * unitPrice;

            return (
              <tr key={item._id || index}>
                <td style={{ textAlign: 'center' }}>{itemNumber}</td>
                <td style={{ textAlign: 'left' }}>
                  <div className="danfe-item-description">
                    {description}
                    {item.productCode && (
                      <span className="danfe-item-code"> ({item.productCode})</span>
                    )}
                  </div>
                </td>
                <td style={{ textAlign: 'center' }}>{formatQuantity(quantity)}</td>
                <td style={{ textAlign: 'right' }}>{financialService.formatCurrency(unitPrice)}</td>
                <td style={{ textAlign: 'right' }}>{financialService.formatCurrency(totalPrice)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Items count */}
      <div style={{ textAlign: 'right', marginTop: 4 }}>
        <Text type="secondary" style={{ fontSize: 10 }}>
          {items.length} {items.length === 1 ? 'item' : 'itens'}
        </Text>
      </div>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default ItemsSection;

// *******************************************************************************
// HELPERS
// *******************************************************************************

/**
 * Format quantity for display
 * @param {number} quantity - Quantity value
 * @returns {string} Formatted quantity
 */
function formatQuantity(quantity) {
  if (Number.isInteger(quantity)) {
    return quantity.toString();
  }
  return quantity.toFixed(3).replace(/\.?0+$/, '');
}
